import { useState } from "react";
import {
    FormControl,
    FormHelperText,
    InputAdornment,
    IconButton,
    TextField,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";

const InputField = ({
    label,
    placeholder,
    error,
    isRequired,
    type,
    defaultValue,
    icon,
    register,
    name,
    inputComponent,
    inputProps,
    isRemoveLabel = false
}) => {
    const [isShowPassword, setIsShowPassword] = useState(false);

    const handleClickShowPassword = () => {
        setIsShowPassword((prev) => !prev);
    };

    const isPasswordField = type === "password";

    return (
        <div className="input-group input-group-outline mb-3">
            <FormControl error={!!error} fullWidth>
                {!isRemoveLabel && <strong>{label}</strong>}
                <TextField
                    placeholder={placeholder}
                    size="small"
                    type={isPasswordField && !isShowPassword ? "password" : "text"}
                    defaultValue={defaultValue}
                    {...register(name, { required: isRequired })}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                {icon}
                            </InputAdornment>
                        ),
                        endAdornment: isPasswordField && (
                            <InputAdornment position="end">
                                <IconButton onClick={handleClickShowPassword} edge="end">
                                    {isShowPassword ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                            </InputAdornment>
                        ),
                        inputComponent: inputComponent || undefined,
                    }}
                    inputProps={{
                        ...inputProps,
                        readOnly: name === "contactContry",
                    }}
                    autoComplete="off"
                    sx={{
                        '& .MuiOutlinedInput-root': {
                            '& fieldset': {
                                borderColor: error ? 'red' : 'rgba(0, 0, 0, 0.23)',
                            },
                            '&:hover fieldset': {
                                borderColor: error ? 'red' : 'black',
                            },
                            '&.Mui-focused fieldset': {
                                borderColor: error ? 'red' : '#3f51b5',
                            },
                        },
                    }}
                />
                {error && <FormHelperText>{error.message}</FormHelperText>}
            </FormControl>
        </div>
    );
};

export default InputField;